import React from 'react';
import LegalDocumentPage from '../components/LegalDocumentPage';

const PrivacyPolicy = () => <LegalDocumentPage slug="privacy" testid="privacy-policy-page" />;

export default PrivacyPolicy;
